module.exports = __webpack_public_path__ + "static/12-df134a01bc72957e60666b566c94767b.jpg";